import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export const comingSoonGuard: CanActivateFn | CanMatchFn = () => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const translate = inject(TranslateService);

  messageService.add({
    severity: 'info',
    summary: translate.instant('comingSoon.toastSummary'),
    detail: translate.instant('comingSoon.toastDetail'),
  });

  return router.parseUrl('/dashboard');
};
